import { createContext, useContext } from 'react';

export const AccordionItemContext = createContext(null);

export const AccordionItemProvider = AccordionItemContext.Provider;

export const useAccordionItemContext = () => useContext(AccordionItemContext);
